import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import { ChevronDown, ChevronRight } from "../icons/v2-stroke";
import { cn } from "../lib/utils";
import { cva } from "class-variance-authority";
import * as React from "react";
import { Icon } from "./Icon";
const labelVariants = cva("inline-flex transition-colors ease-out duration-400 box-border gap-x-2 select-none text-sm", {
    variants: {
        variant: {
            primary: "text-highlight-600",
            secondary: "text-foreground",
        },
        disabled: {
            true: "text-muted",
            false: "group-hover/col:text-highlight-500 active:text-highlight-700",
        },
    },
    defaultVariants: {
        variant: "primary",
        disabled: false,
    },
});
const chevronVariants = cva("transition-transform duration-150", {
    variants: {
        variant: {
            primary: "text-muted-foreground",
            secondary: "text-muted-foreground",
        },
        disabled: {
            true: "text-muted",
            false: "group-hover/col:text-highlight-500 active:text-highlight-700",
        },
    },
    defaultVariants: {
        variant: "primary",
        disabled: false,
    },
});
const Collapsible = React.forwardRef(({ children, className, ...props }, ref) => (React.createElement(CollapsiblePrimitive.Root, { ref: ref, className: className, ...props }, children)));
Collapsible.displayName = "Collapsible";
const CollapsibleTrigger = React.forwardRef(({ label, children, className, disabled = false, hideChevron = false, variant = "primary", ...props }, ref) => {
    return (React.createElement(CollapsiblePrimitive.Trigger, { ref: ref, disabled: disabled, className: cn("group/col flex w-full items-center gap-1 focus:outline-hidden focus:ring-0", disabled ? "cursor-default" : "cursor-pointer", className), ...props },
        !hideChevron && (React.createElement("span", { className: cn("transition-transform duration-200", chevronVariants({ variant, disabled })) },
            React.createElement(Icon, { visual: ChevronRight, size: "sm", className: "block group-data-[state=open]/col:hidden" }),
            React.createElement(Icon, { visual: ChevronDown, size: "sm", className: "hidden group-data-[state=open]/col:block" }))), children !== null && children !== void 0 ? children : (React.createElement("span", { className: labelVariants({ variant, disabled }) }, label))));
});
CollapsibleTrigger.displayName = "CollapsibleTrigger";
const contentVariants = cva("overflow-hidden transition-all", {
    variants: {
        variant: {
            default: "text-foreground",
        },
    },
    defaultVariants: {
        variant: "default",
    },
});
const CollapsibleContent = React.forwardRef(({ children, className, variant, animated = true, ...props }, ref) => (React.createElement(CollapsiblePrimitive.Content, { ref: ref, className: cn(contentVariants({ variant }), animated && [
        "data-[state=closed]:animate-collapse-up data-[state=open]:animate-collapse-down",
        // Open/close still works, it just snaps instead of sliding.
        "motion-reduce:animate-none",
    ], className), ...props }, children)));
CollapsibleContent.displayName = "CollapsibleContent";
export { Collapsible, CollapsibleContent, CollapsibleTrigger };
//# sourceMappingURL=Collapsible.js.map